import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
import AddRolePermissions from "./AddPermission.jsx";
import { RolePermissionApi } from "../../../../App/api/role_and_permissions.api.js";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import {columns,searchBy} from './Column.js'
import { toast } from "react-toastify";
import ConfirmPopup from "../../../../Components/ConfirmPopup.jsx";
import { useSelector } from "react-redux";

const RolesPermission = ({meta, disabledFilters}) => {
  const [pagination,setPagination]=useState({
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  })

  const handlePagination=(data)=>{
    // console.log(data);
    
    if (data.clearPagination) {
      setPagination(data.clearPagination)
      return
    }
    
    setPagination((prev)=>{
        let copyfilter={...prev.filter}
        // copyfilter[]
       
        if (data.filter) {
          // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
          // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
          
          if (copyfilter[Object.keys(data.filter)[0]]) {
            copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
            
          }else{

            copyfilter={...data?.filter,...copyfilter}
          }
        
        }
       
  
        return{
          page:data.page?data.page:prev.page,
          limit:data.limit?data.limit:prev.limit,
          sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
          filter:copyfilter
        }
  
      })
    }
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const { value, fetchAllData } = useFetchAll(() => RolePermissionApi.getAllRolePermissions(pagination,search)); 

 
  const [selectedCell, setSelectedCell] = useState(null);
  const [ModalOpen, setModalOpen] = useState(false);
  const [editRolePermissions, setEditRolePermissions] = useState(null);
  const [isConfirm, setIsConfirm] = useState(false);

 

  const closeRoleModal = () => {
    setModalOpen(false);
    setEditRolePermissions(null);
  };

  const handleRowClick = (row) => {
    setSelectedCell(row);
    setModalOpen(true);
  };

  const handleCellClick = async(cell, field = "") => {
    // console.log("cell",cell);
    // console.log("field",field);
    

    if (field === "roleId") {
      setEditRolePermissions(cell);
      setModalOpen(true);
    }
    if (field === "permissions") {
      setEditRolePermissions(cell);
      setIsConfirm(true);    
    }
  };

  const updatePermission = async () => {
    const payload={
      permissions:editRolePermissions.permissions
    }
    try {
      const response =  await RolePermissionApi.updateRolePermission(payload, editRolePermissions.id)
      fetchAllData()
      toast.success('Permission Updated successfully!')
      
    } catch (error) {
      // console.log(error);
      
    }
    finally {    
      setEditRolePermissions(null);
        setIsConfirm(false);
    
      }
   
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback((s) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(s);
    }, 1500);
  }, [handleSearch]);
const { theme } = useSelector((state) => state.theme);
  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {}
    };
    setSearch("")
    handlePagination && handlePagination(clearPagination);
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

 

  return (
    <div className={`p-5`}>
      <BasicTable
        columns={columns}
        data={value?.data?.allRolePermission || []}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: value?.data?.page || 1,
          rows: value?.data?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: value?.data?.totalPages || 1,
          totalCount: value?.data?.totalCount || 1
        }}
        onCellClick={(e) => console.log("Cell Data", e)}
        handleSearch={debouncedSearch}
        SearchBy={searchBy}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        selectedData={selectedCell}
        handleCellClick={handleCellClick}
        button_name="Add Role & Permissions"
        handleButton={() => {
          setModalOpen(true);
        }}
      />
      <AddRolePermissions
        getAllData={fetchAllData}
        currentItems={editRolePermissions}
        open={ModalOpen}
        handleClose={closeRoleModal}
      />
       <ConfirmPopup
        isOpen={Boolean(isConfirm)}
        onClose={() => {setEditRolePermissions(null);setIsConfirm(false);}}
        onDelete={() => updatePermission()}
        labels={{
          heading: "Are you sure?",
          paragraph: `Did you want to update permission!`,
          button: "Yes",
        }}
      />
    </div>
  );
};

export default RolesPermission;
